<template>
  <content-root class="show-episodes-root">
    <sidebar>
      <sidebar-item class="add_episode" :class="{ 'open': dropdownAddOpen }">
        <app-radio-button
          name="addEpisode"
          :title="translations.addEpisode"
          v-model="currentRadio"
          :value="radioAdd"
        />
        <sidebar-add-episode :item="item" @refreshEpisodes="refreshEpisodes" />
      </sidebar-item>
      <sidebar-item class="episode_db" :class="{ 'open': dropdownFromOpen }">
          <app-radio-button
            name="CSFD"
            :title="translations.csfd"
            v-model="currentRadio"
            :value="radioFromCSFD"
          />
          <app-radio-button
            name="SZ"
            :title="translations.serialZone"
            v-model="currentRadio"
            :value="radioFromSZ"
          />
        <sidebar-series-list :series="{}" />
      </sidebar-item>
    </sidebar>
    <episodes-main-content
      :series="series"
      :pending="pending"
      @deleteAll="clickDeleteAll"
      @deleteSeries="clickDeleteSeries"
      @deleteEpisode="clickDeleteEpisode"
    />
  </content-root>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ContentRoot from './ContentRoot'
import Sidebar from './Sidebar/Sidebar'
import SidebarItem from './Sidebar/SidebarItem'
import SidebarAddEpisode from '../EpisodeSidebar/SidebarAddEpisode'
import SidebarSeriesList from './SidebarSeriesList'
import EpisodesMainContent from './EpisodesMainContent'
import { showDeleteDialog } from '../../../utils/dialog'

const RADIO_EPISODE_ADD = 'RADIO_EPISODE_ADD'
const RADIO_EPISODE_FROM_CSFD = 'RADIO_EPISODE_FROM_CSFD'
const RADIO_EPISODE_FROM_SERIALZONE = 'RADIO_EPISODE_FROM_SERIALZONE'

export default {
  name: 'episodes',
  components: {
    ContentRoot,
    Sidebar,
    SidebarItem,
    SidebarAddEpisode,
    SidebarSeriesList,
    EpisodesMainContent
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  created() {
    if (this.item._id) {
      this.refreshEpisodes()
    }
  },
  data() {
    return {
      radioAdd: RADIO_EPISODE_ADD,
      radioFromCSFD: RADIO_EPISODE_FROM_CSFD,
      radioFromSZ: RADIO_EPISODE_FROM_SERIALZONE,
      currentRadio: RADIO_EPISODE_FROM_CSFD
    }
  },
  computed: {
    ...mapState({
      episodes: state => state.episodes.episodes,
      pending: state => state.episodes.pending.episodes
    }),
    translations() {
      return {
        addEpisode: this.$gettext('Přidat epizodu'),
        csfd: this.$gettext('ČSFD'),
        serialZone: this.$gettext('SerialZone'),
      }
    },
    dropdownAddOpen() {
      return this.currentRadio === this.radioAdd
    },
    dropdownFromOpen() {
      return [this.radioFromCSFD, this.radioFromSZ].indexOf(this.currentRadio) !== -1
    },
    series() {
      const result = {}
      if (!this.episodes) {
        return result
      }

      this.episodes.forEach(v => {
        const seriesNum = v.seriesNumber !== null ? v.seriesNumber : 'null'
        if (result[seriesNum]) {
          result[seriesNum].push(v)
        } else {
          result[seriesNum] = [v]
        }
      })

      return result
    }
  },
  methods: {
    ...mapActions([
      'getEpisodes', 'createEpisode', 'deleteEpisode', 'deleteEpisodes'
    ]),
    clickDeleteAll() {
      const episodes = []
      Object.keys(this.series).forEach(s => {
        this.series[s].forEach(v => episodes.push(v._id))
      })

      showDeleteDialog(this, {
        apiMethod: 'deleteEpisodes',
        data: {
          episodeIdsToBeDeleted: episodes
        }
      })
    },
    clickDeleteSeries(seriesId) {
      const episodes = []
      this.series[seriesId].forEach(v => episodes.push(v._id))

      this.deleteEpisodes({
        data: {
          episodeIdsToBeDeleted: episodes
        }
      })
    },
    clickDeleteEpisode(episodeId) {
      this.deleteEpisode({
        params: {
          id: episodeId
        }
      })
    },
    refreshEpisodes() {
      this.getEpisodes({
        params: {
          show: this.item._id,
          order: 'episodeNumber',
          limit: 10000
        }
      })
    }
  }
}
</script>
